import { getUrl, Request } from '../../request';

export const getLanguage = () => Request.get(getUrl('/api/v1/locations/ipgeolocation/'));
